import { createGlobalStyle } from 'styled-components';
import styled from 'styled-components';

export const GlobalStyle = createGlobalStyle`
	:root {
		--bg: #ffffff;

		--font-size: 16px;

		--color-accent: #EA394B;
		--color-font: #2C2E32;
		--color-second-font: #AAAAAA;

		--radius-extra-small: 8px;
		--radius-small: 16px;
		--radius-medium: 24px;
		--radius-large: 32px;
		--radius-extra-large: 48px;

		--shadow-contour: 0 0 5px 0 rgba(0, 0, 0, .5);
		--shadow-extra-small: 0 0 5px 1px rgba(0, 0, 0, .10);
		--shadow-small: 0 0 10px 3px rgba(0, 0, 0, .10);
		--shadow-medium: 0 0 15px 6px rgba(0, 0, 0, .10);
		--shadow-large: 0 0 20px 9px rgba(0, 0, 0, .10);
		--shadow-extra-large: 0 0 25px 12px rgba(0, 0, 0, .10);
	}
	*,
	*::before,
	*::after {
		padding: 0;
		margin: 0;
		border: 0;
		box-sizing: border-box;
	}
	a {
		text-decoration: none;
		cursor: pointer;
	}
	ul,
	ol,
	li {
		list-style: none;
	}
	img {
		vertical-align: top;
	}
	button{
		font-family: inherit;
		background: transparent;
		cursor: pointer;
	}
	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		font-weight: inherit;
		font-size: inherit;
	}
	html,
	body {
		height: 100%;
		line-height: 1.3;
		font-size: var(--font-size);
	}
	@font-face {
		font-family: 'SF Pro Display';
		src: url('/fonts/SF-Pro-Display-Medium.otf') format('opentype');
		font-weight: 500;
		font-style: normal;
	}

	@font-face {
		font-family: 'SF Pro Display';
		src: url('/fonts/SF-Pro-Display-Bold.otf') format('opentype');
		font-weight: 700;
		font-style: normal;
	}

	@font-face {
		font-family: 'SF Pro Display';
		src: url('/fonts/SF-Pro-Display-Regular.otf') format('opentype');
		font-weight: 400;
		font-style: normal;
	}
	html,
	body {
		font-family: 'SF Pro Display', Arial, Helvetica, sans-serif !important;
	}
	.ant-picker-panels {
		@media (max-width: 768px) {
			flex-direction: column;
		}
	}
	.ant-picker-cell-disabled::before {
		background: transparent !important;
	}
	input::placeholder,
	textarea::placeholder,
	.ant-input::placeholder,
	.ant-input-number-input::placeholder,
	.ant-picker-input input::placeholder,
	.ant-select-selection-placeholder,
	.ant-input-textarea::placeholder,
	.ant-input-affix-wrapper input::placeholder {
		color: #cccccc !important;
	}
	@media print {
		body, html, #root {
			margin: 0 !important;
			padding: 0 !important;
			background: white !important;
		}
		* {
			-webkit-print-color-adjust: exact !important;
			print-color-adjust: exact !important;
		}
	}
`;

export const antdToken = {
	fontFamily: 'SF Pro Display, Arial, Helvetica, sans-serif',
	fontSize: 16,
	colorPrimary: '#EA394B',
	
	Layout: {
		bodyBg: '#f7f7f7',
		
		headerBg: '#ffffff',
		headerColor: '#EA394B',
		headerHeight: 45,
		headerPadding: '0 30px',

		siderBg: '#ffffff',
		triggerBg: '#ffffff',
		triggerColor: '#000000',

		footerBg: '#ffffff',
	},
}

export const antdComponents = {
	Modal: {
		confirmBodyBg: '#ffffff',
	},
	
	Button: {
		colorPrimary: '#EA394B',
		primaryColor: '#ffffff',
		colorPrimaryHover: '#d6313f',
		colorPrimaryActive: '#c22835',
	},
}

export const Flex = styled.div`
	display: flex;
	flex-direction: ${(props) => props.column && 'column'};
	flex: ${(props) => props.flex && props.flex};
	justify-content: ${(props) => props.justify && props.justify};
	align-items: ${(props) => props.align && props.align};
	gap: ${(props) => props.gap && props.gap};
	flex-wrap: ${(props) => props.wrap && 'wrap'};
	max-width: 100%;
	min-width: 0;
`
export const Container = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	max-width: ${(props) => props.$width ? props.$width : '1440px'};
	margin: 0 auto;
	padding: 0 10px;
	@media (max-width: 1470px) {
		max-width: ${props => props.$width ? props.$width : '1200px'};
	}
	@media (max-width: 1230px) {
		max-width: ${props => props.$width ? props.$width : '1024px'};
	}
	@media (max-width: 1054px) {
		max-width: 100%;
	}
`
export const ScrolledCol = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	flex: ${(props) => props.width ? `0 0 ${props.width}` : 1};
	height: 100%;
	max-height: ${(props) => props.height ? props.height : 'calc(100vh - 45px)'};
	overflow-x: hidden;
	overflow-y: auto;
	&::-webkit-scrollbar {
		width: 5px;
	}
	&::-webkit-scrollbar-thumb {
		background-color: #f5f5f5;
		border-radius: 5px;
		transition: all 0.3s ease;
	}
	&::-webkit-scrollbar-track {
		background-color: #f5f5f5;
		border: 1px solid #f5f5f5;
	}
	&:hover::-webkit-scrollbar-thumb {
		background-color: #999999;
	}
`
export const VerticalSpace = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	padding: ${({space}) => space ? `${space}px` : '16px'} 0;
	@media (max-width: 500px) {
		padding: 16px 0 32px;
	}
`
export const PageHeader = styled(Flex)`

`
export const PageContent = styled(Flex)`
	flex-direction: column;
`
export const Title = styled.div`
	display: flex;
	gap: 15px;
	font-size: ${(props) => props.level === 1
							? '32px'
							: props.level === 2
							? '24px'
							: props.level === 3
							? '20px'
							: props.level === 4
							? '18px'
							: props.level === 5
							? '16px'
							: '32px'};
	font-weight: ${(props) => props.weight ? props.weight : 500};
	text-align: ${(props) => props.align && props.align};
	color: ${(props) => props.secondary ? 'var(--color-second-font)' : props.color ? props.color : 'inherit'};
	@media (max-width: 500px) {
		font-size: ${(props) => props.level === 1
								? '24px'
								: props.level === 2
								? '20px'
								: props.level === 3
								? '16px'
								: props.level === 4
								? '14px'
								: props.level === 5
								? '12px'
								: '24px'};
	}
`
export const Text = styled.p`
	font-size: ${(props) => props.size ? props.size : 'var(--font-size)'};
	text-align: ${(props) => props.align && props.align};
	color: ${(props) => props.secondary ? 'var(--color-second-font)' : props.color ? props.color : 'inherit'};
	text-decoration: ${(props) => props.link && 'underline'};
	color: ${(props) => props.link && '#2c5bf7'};
	cursor: ${(props) => props.link && 'pointer'};
	${(props) =>
        props.$ellipsis &&
        `
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    `}
`
export const CardSection = styled.div`
	display: flex;
	flex-direction: column;
	background: #F9F9F9;
	border: solid 1px #EAEAEA;
	border-radius: 24px;
	padding: 24px;
	width: 100%;
	overflow: hidden;
	@media (max-width: 500px) {
		padding: 12px 16px;
	}
`